<template>
  <div class="relative monitor-map">
    <div class="absolute top-0 w-full h-full">
      <mgl-map
        class="w-full h-full"
        ref="map"
        :access-token="accessToken"
        :map-style="mapStyle"
        :zoom="10"
        @load="mapLoaded">
          <template v-for="vehicle in vehicles">
            <mgl-marker :coordinates="[vehicle.longitude / 1000000, vehicle.latitude / 1000000]" :key="vehicle.id">
              <mgl-popup :showed="true" :close-button="false" :close-on-click="false" :offset="8">
                <div class="py-1 leading-none text-center">
                  <div>{{ vehicle.objectname }} </div>
                  <div class="text-gray-400">{{ vehicle.objectno }}</div>
                </div>
              </mgl-popup>
              <div slot="marker">
                <div class="flex items-center justify-center w-4 h-4 bg-indigo-500 bg-opacity-25 rounded-full">
                  <div class="w-2 h-2 bg-indigo-500 rounded-full"></div>
                </div>
              </div>
            </mgl-marker>
          </template>
      </mgl-map>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import { MglMap, MglMarker, MglPopup } from 'vue-mapbox'

export default {
  name: 'MonitorMap',

  components: {
    MglMap,
    MglMarker,
    MglPopup
  },

  created () {
    this.getVehicles()

    this.poll = setInterval(() => { 
      this.getVehicles()
    }, 15000)

    this.$store.subscribeAction((action, state) => {
      if (action.type === 'publishEvent' && action.payload.name === 'locateVehicle') {
        this.locateVehicle(action.payload.data)
      }
    })
  },

  beforeDestroy () {
    clearInterval(this.poll)
  },

  data () {
    return {
      vehicles: {},
      poll: '',
      accessToken: 'pk.eyJ1IjoiZmxlZXRiZWFjb24iLCJhIjoiY2puZXczdHhmMHFqeDNrbGZ3dGNmbGU2cCJ9.dZ0JMOD5222pAk-pR6wzYQ',
      mapStyle: 'mapbox://styles/fleetbeacon/ckcw7i47m15m71imu9z9329lr',
    }
  },

  methods: {
    async getVehicles () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/monitor/map`)

        this.vehicles = data.vehicles
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },

    fitBounds () {
      let bounds = new mapboxgl.LngLatBounds()

      this.vehicles.forEach(v => {
        bounds.extend([Number(v.longitude) / 1000000, Number(v.latitude) / 1000000])
      })

      this.$refs.map.map.fitBounds(bounds, {
        padding: {
          top: 128,
          left: 128,
          bottom: 128,
          right: 128
        }
      })
    },

    mapLoaded () {
      this.fitBounds()
    },

    locateVehicle (vehicle) {
      if (!this.$refs.map) {
        return
      }
      
      const located = this.vehicles.find(v => v.objectuid === vehicle.objectuid)
      
      this.$refs.map.map.flyTo({
        center: [Number(located.longitude) / 1000000, Number(located.latitude) / 1000000],
        zoom: 15
      })
    }
  }
}
</script>

<style lang="postcss">
.monitor-map {
  .mapboxgl-popup-content {
    @apply px-2 shadow-none py-0 font-medium text-xs bg-gray-700 text-white;
  }

  .mapboxgl-popup-tip {
    @apply border-4;
  }

  .mapboxgl-popup-anchor-bottom,
  .mapboxgl-popup-anchor-bottom-left,
  .mapboxgl-popup-anchor-bottom-right, {
    .mapboxgl-popup-tip {
      border-top-color:theme('colors.gray.700');
    }
  }

  .mapboxgl-popup-anchor-top,
  .mapboxgl-popup-anchor-top-left,
  .mapboxgl-popup-anchor-top-right {
    .mapboxgl-popup-tip {
      border-bottom-color:theme('colors.gray.700');
    }
  }

  .mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
    border-right-color:theme('colors.gray.700');
  }

  .mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
    border-left-color:theme('colors.gray.700');
  }
}
</style>